/**
 * @file DeleteQueueDialog.jsx
 * @description DeleteQueueDialog component for displaying and managing delete queue dialog.
 * @component DeleteQueueDialog
 * @exports DeleteQueueDialog - Main component for displaying and managing delete queue dialog.
 */

import { Button, Box } from "@mui/material";
import { QUEUE_STRINGS } from "../../../common/constants/ivrModule/queueConstants.js";
import { STRINGS, VARIANTS, BUTTON_COLORS } from "../../../common/constants/commonConstants.js";
import DialogComponent from "../../../common/components/DialogComponent.jsx";

const AddEditQueueDialog = ({
    onDelete,
    selectedQueue,
    open,
    onClose,
}) => {
    return (
        <>
            <DialogComponent
                open={open}
                setWidth="xs"
                onClose={onClose}
                title={QUEUE_STRINGS.DELETE_QUEUE}
                actions={
                    <Button
                        onClick={onDelete}
                        variant={VARIANTS.CONTAINED}
                        color={BUTTON_COLORS.ERROR}
                    >
                        {STRINGS.DELETE}
                    </Button>
                }
            >
                <Box>
                    {`${STRINGS.DELETE_CONFIRMATION} "${selectedQueue?.queuename}"?`}
                </Box>
            </DialogComponent>
        </>
    )
};

export default AddEditQueueDialog;